import { render, staticRenderFns } from "./zhyy.vue?vue&type=template&id=d35740c8&scoped=true&"
import script from "./zhyy.vue?vue&type=script&lang=js&"
export * from "./zhyy.vue?vue&type=script&lang=js&"
import style0 from "./zhyy.vue?vue&type=style&index=0&id=d35740c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35740c8",
  null
  
)

export default component.exports